module.exports = __webpack_public_path__ + "static/media/y-industry.69655254.svg";